module.exports = __webpack_public_path__ + "static/media/image-card-2.d2929d67.png";